import { compose } from 'recompose'
import { connect } from 'react-redux'
import { setAllGBBDetails } from './actions'
import { getGBBDetails, getGBBAvailability, getGBBTireSize, getGBBStoreNumber } from 'selectors/getGBBDetails'

const mapStateToProps = state => ({
  gBBDetails: (getGBBDetails(state) || {}),
  gBBAvailable: getGBBAvailability(state),
  gBBTireSize: getGBBTireSize(state),
  gBBStoreNumber: getGBBStoreNumber(state)
})

export default compose(
  connect(mapStateToProps, { setAllGBBDetails })
)
